import {
  GetPressReleasesAlgoliaDocument,
  GetPressReleasesAlgoliaQuery,
  GetPressReleasesAlgoliaQueryVariables,
} from 'generated/graphql';
import { client } from 'lib/graphql/client';
import { populateLocals } from '../utils/populateLocals';

export async function getPressReleaseAlgolia(
  paginatedResults: any[] = [],
  first: number = 999,
  after?: string | null | undefined,
): Promise<any> {
  const initialValue = await client.query<
    GetPressReleasesAlgoliaQuery,
    GetPressReleasesAlgoliaQueryVariables
  >({
    query: GetPressReleasesAlgoliaDocument,
    variables: {
      first: first,
      after: after,
    },
  });

  if (initialValue?.data?.pressReleasesConnection?.pageInfo?.hasNextPage) {
    paginatedResults.push(...initialValue.data.pressReleasesConnection.edges);
    return getPressReleaseAlgolia(
      paginatedResults,
      first,
      initialValue.data.pressReleasesConnection.pageInfo.endCursor,
    );
  } else {
    paginatedResults.unshift(...initialValue.data.pressReleasesConnection.edges);
  }

  return populateLocals(paginatedResults);
}
